const DEFAULT_NONTRANSFORMABLE_URLS = [
  '.svg',
  'cache.net-a-porter.com/images/products',
  'cache.mrporter.com/variants/images',
  'iris-integ.dev.product.ext.net-a-porter.com/mrp'
]

const NON_FORCE_JPG_FORMAT = ['.gif', '.svg']

export const getImageTypes = (item, types = [], shouldFallback = true) => {
  const response = {}
  const pictures = item.pictures || []
  const fallback = shouldFallback ? pictures[0] : {}
  types.forEach((type, index) => {
    response[type] = pictures[index] || fallback || {}
  })
  return response
}

export const getExtension = (imageUrl) => {
  const extensionRegex = /\.(\w{3,4})(?:$|\?)/i
  const extensionMatch = imageUrl.match(extensionRegex)
  if (NON_FORCE_JPG_FORMAT.includes(extensionMatch[0])) {
    return extensionMatch && extensionMatch[1] && extensionMatch[1].toLowerCase()
  }
  return 'jpg'
}

export const getMobileImgAttr = (imageUrl, quality) => {
  const src = `${imageUrl}/w${800}_q${quality}.${getExtension(imageUrl)}`
  const srcSet = `${imageUrl}/w${800}_q${quality}.${getExtension(imageUrl)} 2x`
  return {
    src,
    srcSet
  }
}

export const getRetinaImage = (imageUrl, quality, width) => {
  const src = `${imageUrl}/w${width}_q${quality}.${getExtension(imageUrl)}`
  const retinaUrl = `${imageUrl}/w${width * 2}_q${quality}.${getExtension(imageUrl)}`
  const srcSet = `${src} 1x, ${retinaUrl} 2x`
  return {
    srcSet
  }
}

export const getResponsiveImage = (imageUrl, quality, width = [1000, 1500]) => {
  const srcSet = width.map((w) => `${imageUrl}/w${w}_q${quality}.${getExtension(imageUrl)} ${w}w`).join(', ')

  return {
    srcSet
  }
}

// for storybook and temporary for TON static page, MRP hub and static page
export const getRestImageUrlAttr = (imageUrl, width = [1000, 1500]) => {
  const src = `${imageUrl}?imwidth=${800}&improfile=isc`
  const srcSet = width.map((w) => `${imageUrl}?imwidth=${w}&improfile=isc ${w}w`).join(', ')

  return {
    src,
    srcSet
  }
}

export const getImgAttributes = (imageUrl = '', quality, width, nonTransformableUrls = DEFAULT_NONTRANSFORMABLE_URLS, isMobile) => {
  const isNonTransformableUrl = Boolean(nonTransformableUrls.find((nonTransformableUrl) => imageUrl.indexOf(nonTransformableUrl) > -1))
  const imageSphereDomains = [
    'cache.mrporter.com',
    'cache.net-a-porter.com',
    'imagesphere',
    'www.theoutnet.com/cms',
    'preprod.theoutnet.com/cms',
    'www.net-a-porter.com/content/',
    'www.mrporter.com/content/'
  ]
  const isImageSphereDomains = imageSphereDomains.some((domain) => imageUrl.indexOf(domain) > -1)
  const noQueryParams = ['www.net-a-porter.com/variants/', 'data:image', 'www.mrporter.com/variants/']
  const isNoQuery = noQueryParams.some((domain) => imageUrl.indexOf(domain) > -1)

  if (isNonTransformableUrl || isNoQuery) {
    return {
      src: imageUrl,
      srcSet: [imageUrl]
    }
  } else if (isImageSphereDomains) {
    if (isMobile) {
      return getMobileImgAttr(imageUrl, quality)
    } else if (width && !Array.isArray(width)) {
      return getRetinaImage(imageUrl, quality, width)
    }
    return getResponsiveImage(imageUrl, quality, width)
  }
  return getRestImageUrlAttr(imageUrl, width)
}
